import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IconButton, Popper, Snackbar, ClickAwayListener } from "@mui/material";
import { useState } from "react";
import {
  fetchAsignacionesTrabajos,
  definirFechaAsignacion,
  asignacionFechaEjecucion,
  concluirAsignacion,
  desconcluirAsignacion,
  deleteAsignacion,
  cambiarTipoCalculoProgreso,
} from "../../components/functions/Projects";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import Instaladores from "../../assets/img/svg/providers/instaladores.svg";
import LoaderDialog from "../../ui/loader/Loader";
import FechaAsignacionModal from "../../features/asignacionTrabajoModal/FechaAsignacionModal";
import FechaEjecucionModal from "../../features/asignacionTrabajoModal/FechaEjecucionModal";
import CalculoProgresoModal from "../../features/asignacionTrabajoModal/CalculoProgresoModal";
import ConfirmDialog from "../../features/asignacionTrabajoModal/ConfirmDialog";
import DesconcluirModal from "../../features/asignacionTrabajoModal/DesconcluirModal";
import Editar from "../../assets/img/svg/users/editar.svg";
import LinearProgress from "@mui/material/LinearProgress";
import VisitasTrabajoModal from "../../features/asignacionTrabajoModal/VisitasTrabajoModal";

const TablaAsignaciones = ({ asignaciones, user, API_URL, trabajo, fase }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [selectedAsignacion, setSelectedAsignacion] = useState(null);

  const [data, setData] = useState(asignaciones);

  const [openModalFechaAsignacion, setOpenModalFechaAsignacion] =
    useState(false);

  const [openModalFechaEjecucion, setOpenModalFechaEjecucion] = useState(false);

  const [openModalCalculoProgreso, setOpenModalCalculoProgreso] =
    useState(false);

  const [openConfirmDialog, setOpenConfirmDialog] = useState({
    open: false,
    title: "",
    content: "",
    onClose: () => {},
    onConfirm: () => {},
  });

  const [openDesconcluirModal, setOpenDesconcluirModal] = useState(false);

  const [openVisitasTrabajoModal, setOpenVisitasTrabajoModal] = useState(false);

  const snack = (msg) => {
    setShowSnackbar(true);
    setSnackbarMessage(msg || "");
  };

  const reloadData = async () => {
    if (fase && trabajo) {
      try {
        const asignacionesRes = await fetchAsignacionesTrabajos(
          API_URL,
          trabajo?.id,
          fase
        );
        setData(asignacionesRes);
      } catch (error) {}
    }
  };

  const actualizarFechaAsignacion = async (fecha) => {
    const payload = {
      ...selectedAsignacion,
      fechaAsignacion: fecha,
    };

    try {
      setShowLoader(true);
      await definirFechaAsignacion(API_URL, payload);
      await reloadData();
      setShowLoader(false);
      snack("Fecha de asignación actualizada");
    } catch (error) {
      setShowLoader(false);
      snack("Error al actualizar la fecha de asignación");
    }

    setSelectedAsignacion(null);
    setOpenModalFechaAsignacion(false);
  };

  const actualizarFechaEjecucion = async (fechaInicio, fechaFin) => {
    const payload = {
      ...selectedAsignacion,
      fechaEjecucion: fechaInicio,
      fechaEjecucionFin: fechaFin,
    };

    try {
      setShowLoader(true);
      await asignacionFechaEjecucion(API_URL, payload);
      await reloadData();
      setShowLoader(false);
      snack("Fecha de ejecución actualizada");
    } catch (error) {
      setShowLoader(false);
      snack("Error al actualizar la fecha de ejecución");
    }
    setSelectedAsignacion(null);
    setOpenModalFechaEjecucion(false);
  };

  const actualizarCalculoProgreso = async (tipoCalculoProgreso, progreso) => {
    const payload = {
      ...selectedAsignacion,
      tipoCalculoProgreso,
      progreso: progreso || 0,
    };

    if (!tipoCalculoProgreso) {
      return;
    }

    try {
      setShowLoader(true);
      await cambiarTipoCalculoProgreso(API_URL, payload);
      await reloadData();
      setShowLoader(false);
      snack("Calculo de progreso actualizado");
    } catch (error) {
      setShowLoader(false);
      snack("Error al actualizar el calculo de progreso");
    } finally {
      setSelectedAsignacion(null);
      setOpenModalCalculoProgreso(false);
    }
  };

  const handleDesconcluirAsignacion = async (razon) => {
    try {
      setShowLoader(true);
      await desconcluirAsignacion(
        API_URL,
        selectedAsignacion.contenidoDinamicoId,
        razon
      );
      await reloadData();
      setShowLoader(false);
      snack("Asignación desconcluida");
    } catch (error) {
      setShowLoader(false);
      snack("Error al desconcluir la asignación");
    }
    setSelectedAsignacion(null);
    setOpenDesconcluirModal(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <TableContainer component={Paper}>
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontFamily: "Nunito" }}>Nombre</TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Gafete
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Estatus
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Asignado por
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Fecha de asignación
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Fecha de ejecución
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Fecha de término
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Tipo de cálculo de progreso
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Progreso
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Comentarios
              </TableCell>
              <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={row?.asignacionId}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell
                  sx={{ fontFamily: "Nunito" }}
                  component="th"
                  scope="row"
                >
                  {row?.nombreInstalador ||
                    row?.contactoInstalador.nombre ||
                    ""}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  {row?.numGafete}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  {row?.estatusAsignacion.descripcion}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  {row?.usuarioAsigna?.nombre}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  {row?.fechaAsignacion ? (
                    new Date(row?.fechaAsignacion).toLocaleString("es-MX", {
                      dateStyle: "short",
                      timeStyle: "short",
                    })
                  ) : (
                    <IconButton
                      onClick={(e) => {
                        setAnchorEl(null);
                        setSelectedAsignacion(row);
                        setOpenModalFechaAsignacion(true);
                      }}
                    >
                      <img src={Editar} alt="" />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <p style={{ margin: 0, textAlign: "left" }}>
                      {row?.fechaEjecucion
                        ? new Date(row?.fechaEjecucion).toLocaleString(
                            "es-MX",
                            {
                              dateStyle: "short",
                              timeStyle: "short",
                            }
                          ) + " - "
                        : ""}
                      {row?.fechaEjecucionFin
                        ? new Date(row?.fechaEjecucionFin).toLocaleString(
                            "es-MX",
                            {
                              dateStyle: "short",
                              timeStyle: "short",
                            }
                          )
                        : ""}
                    </p>

                    <IconButton
                      onClick={(e) => {
                        setAnchorEl(null);
                        setSelectedAsignacion(row);
                        setOpenModalFechaEjecucion(true);
                      }}
                    >
                      <img src={Editar} alt="" />
                    </IconButton>
                  </div>
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  {row?.trabajoConcluido
                    ? new Date(row?.trabajoConcluido).toLocaleString("es-MX", {
                        dateStyle: "short",
                        timeStyle: "short",
                      })
                    : ""}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  {row?.tipoCalculoProgreso?.esAutomatico
                    ? "Automático"
                    : "Manual"}
                  {user?.perfil?.esAdministrador && (
                    <IconButton
                      onClick={(e) => {
                        setAnchorEl(null);
                        setSelectedAsignacion(row);
                        setOpenModalCalculoProgreso(true);
                      }}
                    >
                      <img src={Editar} alt="" />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="center">
                  {parseInt(row?.progreso) || 0}%
                  <LinearProgress
                    color="success"
                    variant="determinate"
                    value={parseInt(row?.progreso) || 0}
                    sx={{
                      marginTop: 1,
                      height: 6,
                      borderRadius: 5,
                    }}
                  />
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  {row?.comentarios}
                </TableCell>
                <TableCell sx={{ fontFamily: "Nunito" }} align="left">
                  <button
                    id={row?.asignacionId + "button"}
                    key={row?.asignacionId + "button"}
                    onClick={(e) => {
                      handleClick(e);
                      setSelectedAsignacion(row);
                    }}
                    className="action-icon"
                  >
                    <img
                      src={Ajustes}
                      alt="Acciones"
                      style={{ width: 20, height: 20 }}
                    />
                  </button>
                  <Popper
                    open={
                      open &&
                      selectedAsignacion?.asignacionId === row?.asignacionId
                    }
                    anchorEl={anchorEl}
                    placement="bottom-start"
                    style={{ zIndex: 9999 }}
                  >
                    <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                      <div
                        className="dropdown-menu-user"
                        style={{
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: 4,
                          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                          marginTop: 5,
                          padding: 5,
                          minWidth: 100,
                        }}
                      >
                        {row?.estatusAsignacion?.lenguaje !== "CONCLUDED" && (
                          <p
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              padding: "5px 10px",
                            }}
                            onClick={(e) => {
                              if (
                                !row?.fechaEjecucion ||
                                !row?.fechaEjecucionFin
                              ) {
                                snack(
                                  "Debe definir la fecha de ejecución para concluir la asignación"
                                );
                                return;
                              }
                              setAnchorEl(null);

                              setOpenConfirmDialog({
                                open: true,
                                title: "Confirmar",
                                content:
                                  "¿Deseas concluir la asignación de trabajo?",
                                onClose: () =>
                                  setOpenConfirmDialog({
                                    open: false,
                                    title: "",
                                    content: "",
                                    onConfirm: () => {},
                                    onClose: () => {},
                                  }),
                                onConfirm: async () => {
                                  setShowLoader(true);
                                  await concluirAsignacion(
                                    API_URL,
                                    row?.asignacionId
                                  );
                                  await reloadData();
                                  setShowLoader(false);
                                  snack("Asignación concluida");
                                  setOpenConfirmDialog({
                                    open: false,
                                    title: "",
                                    content: "",
                                    onConfirm: () => {},
                                    onClose: () => {},
                                  });
                                },
                              });
                            }}
                          >
                            <img
                              src={Editar}
                              alt=""
                              style={{
                                width: 16,
                                height: 16,
                                marginleft: 8,
                              }}
                            />
                            Concluir
                          </p>
                        )}

                        {row?.estatusAsignacion?.lenguaje === "CONCLUDED" && (
                          <p
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              padding: "5px 10px",
                            }}
                            onClick={(e) => {
                              setAnchorEl(null);
                              setSelectedAsignacion(row);
                              setOpenDesconcluirModal(true);
                            }}
                          >
                            <img
                              src={Editar}
                              alt=""
                              style={{
                                width: 16,
                                height: 16,
                                marginleft: 8,
                              }}
                            />
                            Desconcluir
                          </p>
                        )}

                        {row?.estatusAsignacion?.lenguaje !== "CONCLUDED" && (
                          <p
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              padding: "5px 10px",
                            }}
                            onClick={(e) => {
                              setAnchorEl(null);

                              setOpenConfirmDialog({
                                open: true,
                                title: "Confirmación",
                                content:
                                  "La asignación será eliminada, su respectiva evidencia se conservará. ¿Deseas continuar?",
                                onClose: () =>
                                  setOpenConfirmDialog({
                                    open: false,
                                    title: "",
                                    content: "",
                                    onConfirm: () => {},
                                    onClose: () => {},
                                  }),
                                onConfirm: async () => {
                                  setShowLoader(true);
                                  await deleteAsignacion(
                                    API_URL,
                                    row?.asignacionId,
                                    row?.categoriaParametro.name
                                  );
                                  await reloadData();
                                  setShowLoader(false);
                                  snack("Asignación eliminada");
                                  setOpenConfirmDialog({
                                    open: false,
                                    title: "",
                                    content: "",
                                    onConfirm: () => {},
                                    onClose: () => {},
                                  });
                                },
                              });
                            }}
                          >
                            <img
                              src={Eliminar}
                              alt=""
                              style={{
                                width: 16,
                                height: 16,
                                marginleft: 8,
                              }}
                            />
                            Eliminar
                          </p>
                        )}

                        <p
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            padding: "5px 10px",
                          }}
                          onClick={(e) => {
                            setAnchorEl(null);
                            setOpenVisitasTrabajoModal(true);
                          }}
                        >
                          <img
                            src={Instaladores}
                            alt=""
                            style={{
                              width: 16,
                              height: 16,
                              marginleft: 8,
                            }}
                          />
                          Ver visitas al trabajo
                        </p>
                      </div>
                    </ClickAwayListener>
                  </Popper>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <VisitasTrabajoModal
        open={openVisitasTrabajoModal}
        onClose={() => setOpenVisitasTrabajoModal(false)}
        API_URL={API_URL}
        asignacion={selectedAsignacion}
      />

      <FechaAsignacionModal
        open={openModalFechaAsignacion}
        onClose={() => setOpenModalFechaAsignacion(false)}
        onConfirm={actualizarFechaAsignacion}
      />
      <FechaEjecucionModal
        open={openModalFechaEjecucion}
        onClose={() => setOpenModalFechaEjecucion(false)}
        onConfirm={actualizarFechaEjecucion}
        asignacion={selectedAsignacion}
      />

      <CalculoProgresoModal
        open={openModalCalculoProgreso}
        onClose={() => setOpenModalCalculoProgreso(false)}
        onConfirm={actualizarCalculoProgreso}
        API_URL={API_URL}
      />

      <ConfirmDialog
        open={openConfirmDialog.open}
        title={openConfirmDialog.title}
        content={openConfirmDialog.content}
        onClose={openConfirmDialog.onClose}
        onConfirm={openConfirmDialog.onConfirm}
      />

      <DesconcluirModal
        open={openDesconcluirModal}
        onClose={() => setOpenDesconcluirModal(false)}
        onConfirm={handleDesconcluirAsignacion}
      />

      <LoaderDialog open={showLoader} />
    </>
  );
};

export default TablaAsignaciones;
